import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.locations.splice(props.index, 1)
    })
  }
}
